import * as React from 'react';
import { ecsterCreateCart } from '../../api/booking';
import { EcsterConfig } from '../../mrCapTypes';
import { className } from '../../util';

interface Props {
  bookingId: string;
  config: EcsterConfig;
  onSuccess: () => void;
  onlyProducts: boolean;
}

interface State {
}

export class EcsterPayCheckout extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.initCart();
  }

  async initCart() {
    const cartKey = await ecsterCreateCart(this.props.bookingId);
    const script = document.createElement('script');

    script.addEventListener('load', () => {
      EcsterPay.start({
        cartKey,
        showPaymentResult: false,
        shopTermsUrl: this.props.config.termsUrl,
        onPaymentSuccess: () => {
          this.props.onSuccess();
        }
      });
    });

    script.src = this.props.config.script;

    document.body.appendChild(script);
  }

  render() {
    return (
      <div className={className('ecster-pay-container', {onlyProducts: this.props.onlyProducts})}>
        {/* "ecster-pay-ctr" is needed for Ecster */}
        <div id='ecster-pay-ctr'></div>
      </div>
    );
  }
}